module.exports = __webpack_public_path__ + "df7b648ce5356ea1ebce435b3459fd60.ttf";